// Shared atoms used across wizard step components.
import React from "react";
import { AlertCircle } from "lucide-react";

export const SectionLabel = ({ children }) => (
  <div
    style={{
      fontFamily: "'DM Mono', monospace",
      fontSize: 10,
      letterSpacing: "1.8px",
      color: "#9198b0",
      textTransform: "uppercase",
      marginBottom: 6,
    }}
  >
    {children}
  </div>
);

export const FieldError = ({ children }) =>
  children ? (
    <div
      className="flex items-center gap-1.5 mt-1"
      style={{
        fontFamily: "'DM Mono', monospace",
        fontSize: 10,
        color: "#E24B4A",
        letterSpacing: "0.5px",
      }}
    >
      <AlertCircle size={11} /> {children}
    </div>
  ) : null;

export const inputBase = {
  background: "#0d0f18",
  border: "1px solid rgba(255,255,255,0.10)",
  color: "#f0f2f8",
  fontFamily: "'DM Mono', monospace",
  fontSize: 13,
  borderRadius: 6,
  padding: "8px 10px",
  outline: "none",
  width: "100%",
  transition: "border-color 150ms ease",
};

export const STEPS = [
  { num: 1, label: "Template" },
  { num: 2, label: "Details" },
  { num: 3, label: "Parties" },
  { num: 4, label: "Review" },
];
